const URL_API = process.env.REACT_APP_URL_API;

export {
    URL_API,
};